import React from 'react'
import { useTranslation } from 'react-i18next'
import CompanyBillingInformationLoader from './CompanyBillingInformationLoader'

const CompanyBillingInformation = () => {
  const { t } = useTranslation()

  return (
    <div>
      <h2 className='font-bold text-2xl text-[#3D3D3D]'>
        {t('billingInformation')}
      </h2>
      <CompanyBillingInformationLoader />
    </div>
  )
}

export default CompanyBillingInformation
